module.exports = __webpack_public_path__ + "0cac6f286ce26168a1524d959e742d4c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/chubb_us_2023_chart.png
// module id = 1653
// module chunks = 0